import { createApiHandler } from './handler';

const productOrders = {
  apiClient: null,
  path: '/franchises/product-orders',

  setClient(apiClient) {
    this.apiClient = apiClient;
    this.initApiHandler();
  },

  initApiHandler() {
    Object.assign(this, createApiHandler(this.apiClient, this.path));
  },

  async getByBranch(id, params) {
    try {
      const queryParams = new URLSearchParams();
      params.forEach(param => {
        if (param.name && param.value) {
          queryParams.append(param.name, param.value);
        }
      });

      const response = await this.apiClient.get(`${this.path}/branch/${id}?${queryParams.toString()}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

};

export default productOrders;
